// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-cropper {
  width: 100%;
  height: 280px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.image-cropper__loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
}

.image-cropper__loader.visible {
  display: flex;
}

.image-cropper__area {
  height: 100%;
  width: 60%;
  background-color: rgb(181, 181, 181);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.image-cropper__cropper {
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
}

.image-cropper__review {
  height: 145.6px;
  width: 150.4px;
  border: 1px dashed rgb(181, 181, 181);
  overflow: hidden;
  position: relative;
}

.image-cropper__review__markup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 1;
  opacity: .7;
}

.image-cropper__review__markup img {
  height: 100%;
}

.image-cropper__review__target {
  width: 100%;
  height: 100%;
  opacity: .8;
}

.image-cropper__footer {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
}

.image-cropper__footer__left,
.image-cropper__footer__right {
  height: 100%;
  display: flex;
  align-items: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/imageUploader/imageCropper/ImageCropper.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".image-cropper {\n  width: 100%;\n  height: 280px;\n  overflow: hidden;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n}\n\n.image-cropper__loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  display: none;\n}\n\n.image-cropper__loader.visible {\n  display: flex;\n}\n\n.image-cropper__area {\n  height: 100%;\n  width: 60%;\n  background-color: rgb(181, 181, 181);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.image-cropper__cropper {\n  max-width: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.image-cropper__review {\n  height: 145.6px;\n  width: 150.4px;\n  border: 1px dashed rgb(181, 181, 181);\n  overflow: hidden;\n  position: relative;\n}\n\n.image-cropper__review__markup {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: 100%;\n  z-index: 1;\n  opacity: .7;\n}\n\n.image-cropper__review__markup img {\n  height: 100%;\n}\n\n.image-cropper__review__target {\n  width: 100%;\n  height: 100%;\n  opacity: .8;\n}\n\n.image-cropper__footer {\n  width: 100%;\n  height: 60px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.image-cropper__footer__left,\n.image-cropper__footer__right {\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
